export const GoogleMapConstants = {
  LOCATION_MARKER_ICON_WIDTH: 40,
  LOCATION_MARKER_ICON_HEIGHT: 40,
  GET_LOCATION_DETAIL: "GET_LOCATION_DETAIL",
  DEFAULT_COUNTRY_CODE: "PK",
  DEFAULT_LATITUDE: 24.713552,
  DEFAULT_LONGITUDE: 46.675296,
  LONGITUDE: "longitude",
  LATITUDE: "latitude",
  MAX_ZOOM : 14, 
  DEFAULT_ZOOM : 5
};
